import React, { useState, useEffect } from "react"
import { Dialog, Typography, Grid, Paper, TextField} from "@mui/material"
import ButtonWithIcon from "../../components/Button/Button"
import { ReactComponent as CloseSquareIcon } from "src/v2/assets/icons/close-square-icon.svg"
import { ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import PropTypes from "prop-types"

const EditarPromptModal = ({ open, onClose, onConfirm, textoInicial }) => {
    const [texto, setTexto] = useState("")
    
    useEffect(() => {
        if (open) {
            setTexto(textoInicial || "")
        }
    }, [open, textoInicial])

    const handleSalvar = () => {
        onConfirm(texto)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <Paper sx={{ p: 3, borderRadius: 0, backgroundColor: 'background.paper' }}>
                <Grid container direction="column" spacing={2}>

                    <Grid item>
                        <Typography variant="h6" sx={{ color: 'common.white' }}>
                            Editar Prompt
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            multiline
                            minRows={15} 
                            maxRows={20}
                            value={texto}
                            onChange={(e) => setTexto(e.target.value)}
                            fullWidth
                            variant="outlined"
                            placeholder="O prompt aparecerá aqui..."
                            sx={{
                                mt: 1,
                                backgroundColor: 'background.tertiary',
                                borderRadius: 1,
                                '& .MuiInputBase-input': {
                                    color: 'white.main', 
                                    fontFamily: 'monospace', 
                                    fontSize: '0.9rem',
                                    lineHeight: 1.5
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#475569',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#94a3b8',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#94a3b8', 
                                    }
                                }
                            }}
                        />
                    </Grid>

                    <Grid item container justifyContent="flex-end" spacing={2} sx={{ mt: 1 }}>
                        <Grid item>
                            <ButtonWithIcon
                                onClick={onClose}
                                startIcon={<CloseSquareIcon />}
                            >
                                CANCELAR
                            </ButtonWithIcon>
                        </Grid>
                        <Grid item>
                            <ButtonWithIcon 
                                startIcon={<CheckIcon />}
                                onClick={handleSalvar}>
                                SALVAR
                            </ButtonWithIcon>
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        </Dialog>
    )
}

EditarPromptModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    textoInicial: PropTypes.string
}

export default EditarPromptModal